import { Box } from '@mui/material';
import { IconHot } from 'components/common/IconHot';
import { TextHot } from 'components/common/TextHot';
import { getMediaPath } from 'app/functions';
import { spacing } from 'common/theme';

export const BenefitCell = ({ name, imagePath, isBold = false, imageSize = spacing.xxl, gap = spacing.sm }) => {
    return (
      <Box sx={{ display: 'flex', flexFlow: 'row-reverse', alignItems: 'center', gap: `${gap}px` }}>
        <IconHot src={getMediaPath(imagePath)} size={imageSize} />
        <TextHot
          size="xxl"
          bold={isBold ? 'bold' : 'normal'}
          color="primary"
          sx={{ direction: 'auto', unicodeBidi: 'plaintext' }}
        >
          {name}
        </TextHot>
      </Box>
    );
  };